import { useMemo } from "react";

import { CustomPlaylists } from "@/app/modules/Playlists";
import { ErrorPage } from "@/components";
import { TEMPLATE_PLAYLISTS } from "@/const";
import { useMainTabs } from "@/hooks";

export const Playlists = () => {
  const { mainTabs, isLoading } = useMainTabs();

  const playlistTab = useMemo(
    () => mainTabs?.find((t) => t.TemplateId === TEMPLATE_PLAYLISTS),
    [mainTabs],
  );

  if (!isLoading && !playlistTab) {
    return <ErrorPage code={404} />;
  }

  return <CustomPlaylists />;
};
